import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Loader2 } from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Connexion réussie");
      navigate("/admin");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-fegray-light flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Logo size="md" className="mx-auto mb-6" />
          <h1 className="text-3xl font-bold text-fegray-dark">Espace pro</h1>
          <p className="text-sm text-fegray mt-2">Pod DIGIPILOTE · Agence MSC</p>
        </div>

        <form onSubmit={submit} className="fe-card p-7 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs uppercase tracking-wider text-fegray mb-2">Email</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-fegray/50" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="w-full bg-white border border-gray-200 rounded-xl pl-10 pr-4 py-3 text-fegray-dark focus:border-fegreen focus:ring-2 focus:ring-fegreen/20 focus:outline-none"
              />
            </div>
          </div>

          <div>
            <label className="block text-xs uppercase tracking-wider text-fegray mb-2">Mot de passe</label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-fegray/50" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="w-full bg-white border border-gray-200 rounded-xl pl-10 pr-4 py-3 text-fegray-dark focus:border-fegreen focus:ring-2 focus:ring-fegreen/20 focus:outline-none"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="btn-green w-full disabled:opacity-50"
          >
            {loading ? <><Loader2 className="w-4 h-4 animate-spin"/> Connexion…</> : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
